import { types } from 'mobx-state-tree';

export const Performance = types.model({
  totalQuestions: types.optional(types.maybeNull(types.number), 0),
  great: types.optional(types.maybeNull(types.number), 0),
  notAttmpted: types.optional(types.maybeNull(types.number), 0),
  gettingThere: types.optional(types.maybeNull(types.number), 0),
  needReview: types.optional(types.maybeNull(types.number), 0),
  greatPercentage: types.optional(types.maybeNull(types.number), 0),
  notAttmptedPercentage: types.optional(types.maybeNull(types.number), 0),
  gettingTherePercentage: types.optional(types.maybeNull(types.number), 0),
  needReviewPercentage: types.optional(types.maybeNull(types.number), 0)
});

const AssignmentDetails = types.model({
  assignmentId: types.maybeNull(types.string),
  totalQuestions: types.maybeNull(types.number),
  attemptedQuestions: types.maybeNull(types.number),
  questionsAttemptedOnTime: types.optional(types.maybeNull(types.number), 0),
  questionsAttemptedLate: types.optional(types.maybeNull(types.number), 0),
  studentProgress: types.maybeNull(types.string),
  performance: types.maybeNull(Performance),
  dueDate: types.optional(types.maybeNull(types.string), null)
});

export default AssignmentDetails;
